import React, { useState } from "react";
import SlideTitle from "./SlideTitle";
import useFitText from "use-fit-text";

// left, center, right for items-align
export default ({ title, dir = "row", itemsAlign = "center", children }) => {
  const [hidingDuringResize, setHidingDuringResize] = useState(!!title);
  // if there's no title, set this to false, because the resizes will fail.
  let contentHeight = title ? "75vh" : "95vh"; // add space for the title if we have one

  const { fontSize, ref } = useFitText({
    maxFontSize: 100,
    onFinish: () => {
      setHidingDuringResize(false);
    },
  });
  // const { fontSize2, ref2 } = useFitText({
  //   maxFontSize: 200,
  //   onFinish: () => {
  //     setHidingDuringResize(false);
  //   },
  // });

  return (
    <div
      className={`flex flex-col justify-between items-center h-full w-full ${
        hidingDuringResize ? "hide" : "show"
      }`}
    >
      {title ? (
       <SlideTitle> {title} </SlideTitle>
      ) : null}

      <div
        ref={ref}
        style={{
          fontSize: fontSize,
          height: contentHeight,
          marginBottom: "5vh",
          width: "100vw",
          paddingRight: "5vh",
          paddingLeft: "5vh",
        }}
        className={`flex flex-${dir} justify-center items-${itemsAlign}`}
      >
        {children}
      </div>
    </div>
  );
};
